export default __webpack_public_path__ + "static/telco-3-35455e690769d41b6e79e7af1a0e305f.webp";